<template>
  <div class="echarts-view">
    <EchartsFoundation :data="options" />
  </div>
</template>
<script setup>
import { ref, computed } from "vue";
import EchartsFoundation from "./EchartsFoundation.vue";
// import wxIcon from '@/assets/left-bt-bg.png'

//数据
const data = ref([
  { name: "农资", value: 25, color: "#48C5DB" },
  { name: "农事服务", value: 45, color: "#4BDC7B" },
  { name: "农产品", value: 12, color: "#FED25A" },
]);

// 图表配置
const options = computed(() => {
  //总数
  let total = data.value.reduce((a, b) => a + b.value, 0);
  //当前累加值
  let sumValue = 0;
  // 辅助参数,控制饼图半径，（0-1）范围内控制环形大小，值越小环形内半径越大
  let k = 0.2;

  // series配置（每个扇形）
  let series = data.value.map((item) => {
    // 当前扇形起始位置占饼图比例
    let startRatio = sumValue / total;
    // 值累加
    sumValue += item.value;
    //当前扇形结束位置占饼图比例
    let endRatio = sumValue / total;
    return {
      name: item.name ?? null,
      type: "surface", // 曲面图
      itemStyle: {
        color: item.color ?? null, // 颜色
      },
      wireframe: {
        show: false, // 不显示网格线
      },
      pieData: item, // 数据
      // 饼图状态
      pieStatus: {
        k, // 辅助参数
        startRatio, // 起始位置比例
        endRatio, // 结束位置比例
        value: item.value, // 数值
      },
      parametric: true, // 参数曲面
      // 曲面的参数方程
      parametricEquation: getParametricEquation(
        startRatio,
        endRatio,
        k,
        item.value
      ),
    };
  });

  //添加指示线
  // series.forEach((item, index) => {
  //   let {
  //     itemStyle: { color },
  //     pieStatus: { startRatio, endRatio, value },
  //   } = item;
  //   addLabelLine(series, startRatio, endRatio, value, k, index, color);
  // });

  //返回配置
  return {
    // 提示框
    tooltip: {
      // background-image: url("@/assets/left-bt-bg.png");
      formatter: (params) => {
        if (
          params.seriesName !== "mouseoutSeries" &&
          params.seriesName !== "pie2d"
        ) {
          // return series[params.seriesIndex].pieData ? `<div style="width: 127px;height: 72px;margin-right: 5px;border-radius: 10px;
          //   background-image: url(${ wxIcon });">${ params.seriesName }<br/>${series[params.seriesIndex].pieData.value}</div>` : '';
          return series[params.seriesIndex].pieData ? `<div class="tooltip-box"><p class="number">${series[params.seriesIndex].pieData.value}万元</p><p class="name">${ params.seriesName }</p></div>` : '';
        }
        return "";
      },
    },
    legend: {
      type: 'scroll',
      orient: 'vertical',
      right: 0,
      top: 50,
      bottom: 20,
      textStyle:{
        color: '#ffffff',
      }
    },
    xAxis3D: {
      min: -1,
      max: 1,
    },
    yAxis3D: {
      min: -1,
      max: 1,
    },
    zAxis3D: {
      min: -1,
      max: 1,
    },
    grid3D: {
      left: '-10%',
      top: 20,
      show: false, // 不显示坐标系
      boxHeight: 8, // 饼图高度
      // 用于鼠标的旋转，缩放等视角控制
      viewControl: {
        alpha: 30, // 视角
        distance: 180, // 距离，值越大饼图越小
        rotateSensitivity: 0, // 禁止旋转
        zoomSensitivity: 0, // 禁止缩放
        panSensitivity: 0, // 禁止平移
        autoRotate: false, // 禁止自动旋转
      },
    },
    series,
  };
});

/**
 * 获取面的参数方程
 * @param {*} startRatio 扇形起始位置比例
 * @param {*} endRatio 扇形结束位置比例
 * @param {*} k 辅助参数,控制饼图半径
 * @param {*} value 数值
 */
const getParametricEquation = (startRatio, endRatio, k, value) => {
  const startRadian = startRatio * Math.PI * 2;
  const endRadian = endRatio * Math.PI * 2;
  k = typeof k === "number" && !isNaN(k) ? k : 1 / 3; //默认1/3
  // 返回曲面参数方程
  return {
    u: {
      min: -Math.PI,
      max: Math.PI * 3,
      step: Math.PI / 32,
    },
    v: {
      min: 0,
      max: Math.PI * 2,
      step: Math.PI / 20,
    },
    x(u, v) {
      if (u < startRadian) {
        return Math.cos(startRadian) * (1 + Math.cos(v) * k);
      }
      if (u > endRadian) {
        return Math.cos(endRadian) * (1 + Math.cos(v) * k);
      }
      return Math.cos(u) * (1 + Math.cos(v) * k);
    },
    y(u, v) {
      if (u < startRadian) {
        return Math.sin(startRadian) * (1 + Math.cos(v) * k);
      }
      if (u > endRadian) {
        return Math.sin(endRadian) * (1 + Math.cos(v) * k);
      }
      return Math.sin(u) * (1 + Math.cos(v) * k);
    },
    z(u, v) {
      if (u < -Math.PI * 0.5) {
        return Math.sin(u);
      }
      if (u > Math.PI * 2.5) {
        return Math.sin(u) * value * 0.1;
      }
      // 扇形高度根据value值计算
      return Math.sin(v) > 0 ? value * 0.1 : -1;
    },
  };
};

//添加label指示线
/**
 * @param {*} series 配置
 * @param {*} startRatio 扇形起始位置比例
 * @param {*} endRatio 扇形结束位置比例
 * @param {*} value 数值
 * @param {*} k 辅助参数，饼图半径相关
 * @param {*} i  在series中索引
 * @param {*} color 指示线颜色
 */
const addLabelLine = (
  series,
  startRatio,
  endRatio,
  value,
  k,
  i,
  // color = "#fff"
) => {
  //计算扇形中心弧度
  const midRadian = (startRatio + endRatio) * Math.PI;
  // 计算起点位置坐标（扇形边缘中心）
  const radius = 1 + k; // 外径
  const posX = Math.cos(midRadian) * radius; //x坐标
  const posY = Math.sin(midRadian) * radius; //y坐标
  const posZ = 0.1 * value; //z坐标

  let flag =
    (midRadian >= 0 && midRadian <= Math.PI / 2) ||
    (midRadian >= (3 * Math.PI) / 2 && midRadian <= Math.PI * 2)
      ? 1
      : -1;

  //计算拐点坐标
  let turningPosArr = [
    posX * 1.1 + i * 0.1 * flag + (flag < 0 ? -0.2 : 0),
    posY * 1.1 + i * 0.1 * flag + (flag < 0 ? -0.2 : 0),
    posZ,
  ];
  //计算结束位置坐标
  let endPosArr = [
    posX * 1.2 + i * 0.1 * flag + (flag < 0 ? -0.2 : 0),
    posY * 1.2 + i * 0.1 * flag + (flag < 0 ? -0.2 : 0),
    posZ * 3,
  ];

  //添加label+指示线
  series.push(
    //  指示线
    {
      type: "line3D",
      lineStyle: {
        color: "#fff",//线颜色
        width:2,//线宽
      },
      data: [[posX, posY, posZ], turningPosArr, endPosArr],
    },
    // label
    {
      type: "scatter3D",
      label: {
        show: true,
        distance: 0,
        position: "center",
        textStyle: {
          color: "#fff",// 文字颜色
          backgroundColor: "rgba(0,0,0,0)", // 透明背景
          fontSize: 18, // 文字尺寸
          fontWeight: 'bold', // 文字加粗
          padding: 5,
        },
        formatter: "{b}",
      },
      symbolSize: 0,
      data: [
        {
          name: series[i].name + "：" + value+'个',
          value: endPosArr,
        },
      ],
    }
  );
};
</script>
<style scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #203598;
  align-items: center;
}
.echarts-view {
  height: 200px;
  width: 100%;
}
</style>

